import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=362860b2&scoped=true"
import script from "./app-header.ts?vue&type=script&lang=ts&external"
export * from "./app-header.ts?vue&type=script&lang=ts&external"
import style0 from "./app-header.less?vue&type=style&index=0&id=362860b2&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362860b2",
  null
  
)

export default component.exports